<template>
  <div
    class="expand-icon__wrapper pb-3">
    <v-icon
      class="expand-icon"
      small
      @click="showExpandedDialog">
      mdi-arrow-expand
    </v-icon>
  </div>
</template>
<script>
export default {
  name: 'ProductCellExpandedView',
  methods: {
    showExpandedDialog() {
      this.$emit('showExpandedDialog');
    },
  },
};
</script>
<style scoped lang="scss">
.expand-icon__wrapper {
  .expand-icon {
    display: inline-flex !important;
  }
}
</style>
